<template>
  <div class="message-container">
    <div class="message-wrapper">
      <section>
        <p>メッセージ内容</p>
        <textarea class="textarea main-message disp-scroll"
          :value="scenarioEdit.mainmessage"
          placeholder="例：お名前を入力してください"
          @input="$emit('change-mainmessage', $event.target.value)"
          :disabled="isDisable() || scenarioEdit.is_confirm">
        </textarea>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    scenarioEdit: {
      type: Object,
    }
  },
  methods: {
    isDisable(){
      this.$emit('is-disable')
    },
  },
}
</script>

<style lang="scss" scoped>
.message-container {
  .message-wrapper {
    background-color:white;
    section {
      text-align: left;
    }
  }
  .message-content {
    margin-top: 8px;
  }
}
.main-message {
  margin-top: 8px;
}
</style>


// WEBPACK FOOTER //
// src/components/organisms/chatbot/modals/ModalEditMessageParts.vue